import CaseServiceService from './services/CaseServiceService'
import CaseService from './services/CaseService'
import NotificationService from './services/NotificationService'
import CaseServiceLogService from './services/CaseServiceLogService'
import Tracer from './services/Tracer'
import axios from 'axios'
import InvoiceService from "./services/InvoiceService";
import CaseAnomaliesService from "./services/CaseAnomaliesService";
import MetadataService from "./services/MetadataService";

const applicationName = 'mcc-frontend';

const tracer = new Tracer(applicationName);
let axiosInstance = axios.create(); // add interceptors for auth, tracing...
axiosInstance = tracer.configureAxios(axiosInstance);

// base for DI
export const caseServiceService = new CaseServiceService(axiosInstance);
export const caseService = new CaseService(axiosInstance);
export const notificationService = new NotificationService(() => di.store);
export const caseServiceLogService = new CaseServiceLogService(axiosInstance);
export const invoiceService = new InvoiceService(axiosInstance);
export const caseAnomaliesService = new CaseAnomaliesService(axiosInstance);
export const metadataService = new MetadataService(axiosInstance);

export const di = { // for lazy binding work
  store: null,
  router: null
};




// WEBPACK FOOTER //
// ./src/application.js